module.exports = __webpack_public_path__ + "media/icons-for-sprite/icon-close--white-5d987023.svg";